import { render, staticRenderFns } from "./DefaultColorsPickerModal.vue?vue&type=template&id=283ed31c&scoped=true&"
import script from "./DefaultColorsPickerModal.vue?vue&type=script&lang=js&"
export * from "./DefaultColorsPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultColorsPickerModal.vue?vue&type=style&index=0&id=283ed31c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ed31c",
  null
  
)

export default component.exports